export default __webpack_public_path__ + "static/media/asunnonvaihto.97ded778.svg";